// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1nsDw","list":"PatternAutocomplete_list__32YHP"};